import { useEffect, useMemo, useState } from "react";
import { GeoJSON, Marker, Pane, Polyline, Tooltip } from "react-leaflet";
import { useAppSelector } from "Hooks/useRedux";
import { HeatmapLayerFactory } from "@vgrid/react-leaflet-heatmap-layer";
import useWaybill from "Hooks/useWaybill";

const HeatmapLayer = HeatmapLayerFactory<[number, number, number]>();

const ICON_SIZE = 22;

export default function WaybillHeatMap() {
  const { visible, heatmapMode } = useAppSelector((state) => state.waybill);
  const { survayLayer } = useAppSelector((state) => state.layers);
  const { zone } = useAppSelector((state) => state.zones);

  const { data } = useWaybill();

  const [heatMapData, setHeatMapData] = useState<[number, number, number][]>([]);

  const handleHeatMap = (dat: any) => {
    const dataTemp = [];
    for (let i = 0; i < dat?.length; i += 1) {
      const temp: [number, number, number] = [1, 1, 1];
      if (heatmapMode === "source" && dat[i].Result) {
        const waybill = JSON.parse(`{${dat[i].Result}}`);
        temp[0] = waybill.source_lat;
        temp[1] = waybill.source_lng;
      } else if (heatmapMode === "destination" && dat[i].Result) {
        const waybill = JSON.parse(`{${dat[i].Result}}`);
        temp[0] = waybill.destination_lat;
        temp[1] = waybill.destination_lng;
      }
      dataTemp.push(temp);
    }
    setHeatMapData(dataTemp);
  };

  const makeGradient = () => {
    if (heatmapMode === "source") {
      return {
        0.1: "#cdfc9e",
        0.3: "#76c52b",
        0.5: "#5d910c",
        0.6: "#cad004",
        0.8: "#c6a006",
        1: "#d67540",
      };
    }
    if (heatmapMode === "destination") {
      return {
        0.1: "#92fcea",
        0.3: "#70f8f0",
        0.5: "#19c6ba",
        0.6: "#3744aa",
        0.8: "#6e246d",
        1: "#461f69",
      };
    }
  };

  useEffect(() => {
    handleHeatMap(data);
  }, [data, heatmapMode]);

  if (!visible) return <></>;
  return (
    <>
      <Pane name="show_willbay_heatmap" style={{ zIndex: survayLayer }} key={`${zone}${survayLayer}`}>
        <HeatmapLayer
          points={heatMapData}
          longitudeExtractor={(m) => m[1]}
          latitudeExtractor={(m) => m[0]}
          intensityExtractor={(m) => m[2]}
          minOpacity={0.2}
          max={2}
          radius={20}
          opacity={1}
          blur={10}
          gradient={makeGradient()}
        />
      </Pane>
    </>
  );
}
